import axios from "axios";
import { BASE_URL } from "./settings";


const URLS = {
  AG_ATUAL: BASE_URL + "AvaliacaoGenetica",
};

export default class ClassificacaoEstatisticaService {
  
  static filterStatic = async (value) => {
    let url = URLS.AG_ATUAL + "/consultarEstatisticasAvaliacaoGenetica";

    try {
      const { data } = await axios.post(url, value);
      return data;
    } catch (err) {
      return err;
    }
  };
}
